import type { SpecificResourceOverviewCardProps } from '@ctw/shared/content/overview/resource-overview-card';
import { withOverviewCardErrorBoundary } from '@ctw/shared/content/overview/with-overview-card-error-boundary';
import { useResourceDrawer } from '@ctw/shared/context/resource-drawer-context';
import { EpisodeOfCareOverviewCard } from './episode-of-care-overview-card';
import { useEpisodeOfCareOverviewData } from './use-episode-of-care-overview-data';

const TITLE = 'ED & IP Visits';

export const EpisodeOfCareOverview = withOverviewCardErrorBoundary({
  cardTitle: TITLE,
  boundaryName: 'EpisodeOfCareOverviewCard',
  Component: ({ onSeeAllResources }: SpecificResourceOverviewCardProps) => {
    const { openResourceDrawer } = useResourceDrawer({ enableReadActions: true });
    const { data, isLoading, hasNoRecords } = useEpisodeOfCareOverviewData();

    // Footer visibility keys off the filtered list; the empty-state copy keys off
    // the raw fetch so "no records" vs "none within the past year" can differ.
    const isEmpty = data.length === 0;

    return (
      <EpisodeOfCareOverviewCard
        data={data}
        isLoading={isLoading}
        onRowClick={({ telemetry, record }) => {
          openResourceDrawer({ telemetry, model: record });
        }}
        emptyState={
          hasNoRecords
            ? "We didn't find any emergency or inpatient records for this patient."
            : 'No emergency or inpatient visits found within the past year.'
        }
        footerCTA={
          // Keep the CTA visible while loading (chrome renders with a body spinner)
          // and whenever there are records; only hide it once we know there are none.
          isLoading || !isEmpty
            ? {
                label: 'All Encounters',
                onClick: onSeeAllResources,
              }
            : undefined
        }
      />
    );
  },
});
